export const convertMsInSecs = (ms: number) => {
  return ms / 1000
}
